import request from "@/utils/request";

// 拉取配置
export function xcDepConfig(depName) {
  return request({
    url: "/cus/xcDepConfig/" + depName,
    method: "get",
  });
}



// WEBPACK FOOTER //
// ./src/api/depConfig.js